import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
    const navigate = useNavigate();
    const theme = useTheme();       
    const textPrimaryColor = theme.palette.text.primary;
    const backgroundDefault = theme.palette.background.default;

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            height="100%" 
            textAlign="center"
            sx={{ bgcolor: backgroundDefault, padding: 3 }}
        >
            <Box 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                sx={{ fontSize: '6rem', color: '#ff6b6b' }}
            >
                <ErrorOutlineIcon sx={{ fontSize: '6rem' }} />
                <Typography variant="h2" sx={{ fontSize: '3rem', fontWeight: 600 }}>
                    404
                </Typography>
            </Box>
            <Typography variant="h5" mb={2} sx={{ fontWeight: 600, color: textPrimaryColor }}>
                Oops! Not Found
            </Typography>            
            <Button 
                variant="outlined" 
                color="primary" 
                onClick={handleGoHome} 
                sx={{ fontWeight: 600 }}
            >
                Go to Home Page
            </Button>
        </Box>
    );
};

export default NotFound;
